import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
  OnDestroy,
} from "@angular/core";
import { ConversionUtils } from "../../../../domain/conversion-utils";
import moment from "moment";
import { RouteSecEventType } from "../../../../domain/route-sec-event-type";
import { UI } from "../../../../services/ui.service";
import { SecEventsService } from "../sec-events.service";
import { Subscription } from "rxjs";
import { SecEventType } from "../../../../domain/sec-events";
import { SecEventCategory } from "../../../../domain/sec-event-category";
import { Show } from "../../../../domain/show";

@Component({
  selector: "evrideo-calendar-expandable-signal-event",
  templateUrl: "./calendar-expandable-signal-event.component.html",
  styleUrls: ["./calendar-expandable-signal-event.component.scss"],
})
export class CalendarExpandableSignalEventComponent
  implements OnInit, OnDestroy
{
  @Input() secEventType: string;
  @Input() show: Show;
  @Input() eventData;
  @Input() formatTime: (time: moment.Moment) => string;
  @Input() formatDuration: (duration: moment.Duration) => string;
  @Input() toggleSecEvent: (show: Show, eventId: string) => void;

  eventName = "";
  eventIcon = "";

  onEventToggleSubscription: Subscription;
  timeChangeSubscription: Subscription;
  properties;

  constructor(
    private ui: UI,
    private secEventsApi: SecEventsService,
  ) {}

  ngOnInit(): void {
    this.properties = this.eventData.properties;
    switch (this.eventData.type) {
      case SecEventType.SCTE: {
        this.eventName = "SCTE";
        this.eventIcon = "../../assets/icons/SCTE.svg";
        break;
      }
      case SecEventType.Cuetone: {
        this.eventName = "Cuetone";
        this.eventIcon = "../../assets/icons/cuetone.svg";
        break;
      }
    }

    this.onEventToggleSubscription = this.secEventsApi.onEventToggle.subscribe(
      (data) => {
        if (
          data.showId === this.show.id &&
          data.id === this.eventData.properties.id &&
          data.offset === this.eventData.properties.offset
        ) {
          this.eventData.properties.enabled =
            !this.eventData.properties.enabled;
        }
      },
    );

    this.timeChangeSubscription = this.secEventsApi.onTimeChange.subscribe(
      ({
        showId,
        identifier,
        originalOffset,
        newStartTime,
        newOffset,
        newDuration,
        eventType,
      }) => {
        if (
          eventType === SecEventCategory.Signal &&
          showId === this.show.id &&
          identifier === this.eventData.properties.id &&
          originalOffset === this.eventData.properties.offset
        ) {
          this.eventData.properties.startTime = newStartTime;
          this.eventData.properties.offset = newOffset;
          this.eventData.properties.duration = newDuration;
        }
      },
    );
  }

  ngOnDestroy(): void {
    this.onEventToggleSubscription?.unsubscribe();
    this.timeChangeSubscription?.unsubscribe();
  }

  async deleteEvent() {
    try {
      await this.secEventsApi.deleteEvent(
        SecEventCategory.Signal,
        this.show.id,
        this.properties.id,
        this.properties.offset,
      );
    } catch (e) {
      this.ui.notify(this.ui.EVENTS.ShowAlert, {
        title: "Error deleting event",
        message: e.message,
      });
    }
  }
}
